import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enUS from './locales/en-US.json'
import ptBR from './locales/pt-BR.json'
import esES from './locales/es-ES.json'

const resources = {
  'en-US': { translation: enUS },
  'pt-BR': { translation: ptBR },
  'es-ES': { translation: esES },
}

// Determina o idioma inicial pela URL — garante que o cliente hidratar
// com o mesmo idioma que o SSG pré-renderizou, evitando o erro #418.
function getInitialLanguage(): string {
  if (typeof window === 'undefined') return 'pt-BR'
  const path = window.location.pathname
  if (path.startsWith('/en')) return 'en-US'
  if (path.startsWith('/es')) return 'es-ES'
  return 'pt-BR'
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'pt-BR',
    ns: ['translation'],
    defaultNS: 'translation',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    saveMissing: false,
    showSupportNotice: false,
  })

// Guards necessários para SSG: código roda em Node.js durante o build
if (typeof document !== 'undefined') {
  i18n.on('languageChanged', (lng: string) => {
    document.documentElement.lang = lng
  })

  if (i18n.isInitialized) {
    document.documentElement.lang = i18n.language
  } else {
    i18n.on('initialized', () => {
      document.documentElement.lang = i18n.language
    })
  }
}

export default i18n
